<template>
  <div>
    <div class="top-div">
      <div class="span-center" v-show="nickName">
        <div class="img-div">
          <img class="head" :src="headUrl"></img>
        </div>
        <div class="pt10 f28 text-center">{{nickName}}</div>
      </div>
      <!--<button open-type="getUserInfo" lang="zh_CN" bindgetuserinfo="onGotUserInfo"-->
              <!--v-show="userInfo!=null && !userInfo.nickName" type="primary" size="mini"> 授权用户信息-->
      <!--</button>-->
    </div>
    <div>
      <div hover-class="bcEE">
        <div class="tab-div" @click="toCollet">
          <div class="f-blod">我的收藏</div>
          <div class="iconfont icon-xiayishou cc3 f25"></div>
        </div>
      </div>
      <div hover-class="bcEE">
        <div class="tab-div" @click="toBrowse">
          <div class="f-blod">浏览记录</div>
          <div class="iconfont icon-xiayishou cc3 f25"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue"
import http from '@/util/http.js'
import '@/css/personCenter.css'

var vm = vue;
export default {
  name: "personCenter",
  data() {
    return {
      nickName: null,
      headUrl:null
    }
  }, methods: {
    toCollet:function(){
      this.$router.push({
        name: 'collet'
      })
    },
    toBrowse:function(){
      this.$router.push({
        name: 'browse'
      })
    }
  },
  mounted(){
    if(!this.$global.isLogin){
      let url = window.location.href;
      let arr = url.split("code=");
      if(arr.length>1){
        this.code = arr[1].split("&")[0];
        this.$global.login(this.code);
        this.nickName = this.$global.nickName;
        this.headUrl = this.$global.headUrl;
      }else{
        http.getWechatCode();
      }
    }else{
      this.nickName = this.$global.nickName;
      this.headUrl = this.$global.headUrl;
    }
  }
}</script>



// WEBPACK FOOTER //
// src/views/personCenter.vue